import { followUpEpic as epic } from './epic'
import { followUpReducer as reducer } from './reducer'

export const followUpEpic = epic
export const followUpReducer = reducer
